import dateToAge from './dateToAge';
import stringToDate from './stringToDate';

const stringToAge = (str: string | null) => (str ? dateToAge(stringToDate(str)) : '');

export default stringToAge;
